import SEOHead from '@components/SEOHead';
import Header from '@components/layout/Header';
import { MainSection } from '@components/LandingElements/MainSection';
import React from 'react';
import { Footer } from '@components/layout/Footer';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { SimpleFaq } from '@components/LandingElements/SimpleFAQ';
import { CtaBtn } from '@components/LandingElements/CtaBtn';
import { FeatureRightImgSection } from '@components/LandingElements/FeatureSection/FeatureRightImgSection';
import { FeatureLeftImgSection } from '@components/LandingElements/FeatureSection';
import { StepsSection } from '@components/LandingElements/FeatureSection/StepsSection';
import Link from 'next/link';

export default function AiPornGame() {
  const faqContent = [
    {
      question: 'What can I customize when generating an AI nude image?',
      answer:
        'When generating an AI nude image, you have the freedom to customize a wide range of features to match your vision. Choose from different hairstyles, hair colors, eye colors, and body figures to create your ideal AI woman in our create AI Girlfriend Generator. Additionally, you can position your AI in various poses such as standing, sitting, or lying down, paired with emotions ranging from embarrassed to angry, adding depth and realism to your images.',
    },
    {
      question:
        'How do I create or select an AI woman for generating a nude image?',
      answer:
        'To start creating your AI-generated nude image, you can either craft your own unique AI woman or select one from our catalog using the "Photo Content" tag. Once you\'ve made your choice, click on the camera icon to access our customization options. Here, you can specify every detail about your AI woman\'s appearance and pose, or select from our predefined options to quickly generate the image that fits your desires.',
    },
    {
      question:
        'Can I choose different settings for my AI-generated nude images?',
      answer:
        "Yes, our AI nude generator allows you to place your AI woman in a variety of settings to enhance the ambiance of your image. Choose from exotic locations like a beach or jungle, or more intimate settings like a room or bathroom. You have the liberty to set any scene you desire, ensuring your AI-generated nudes perfectly capture the mood and context you're aiming for.",
    },
    {
      question: 'Is it possible to combine AI-generated nudes with stories?',
      answer:
        'Yes, you can combine AI-generated nudes with immersive stories. Engage in conversations with your AI woman, dive into spicy narratives, and explore various scenarios that captivate your imagination. This feature allows for a deeper, more engaging experience as you interact with your creation.',
    },
    {
      question:
        'How can I preview AI-generated nude women before generating my own?',
      answer:
        "Before diving in, you can check out our SFW (Safe For Work) character gallery for a filtered preview of our generator's capabilities. While the gallery shows our AI women in a more modest light, it gives you a hint of the possibilities. To unlock and generate your own AI-generated nude women, you'll need to explore the full features of our generator.",
    },
  ];
  return (
    <>
      <SEOHead
        title="AI Nude Generator: Make Spicy AI Images & Chat with Sexy AI"
        description="Create AI generated nudes of sexy AI girls,  dive into wild stories with them. Use the nude AI generator to choose locations, actions, emotions, and poses!"
        type="website"
        keywords="ai generated nudes, ai nude generator, nude ai generator, ai generated nude, ai generated nude women, ai nudes generator"
        url="https://www.aigirlfriend.wtf/ai-nude-generator"
        imageUrl="https://www.aigirlfriend.wtf/web-banner-min.jpg"
      />
      <Header />
      <main>
        <MainSection
          title={
            <>
              Advanced{' '}
              <span className="!leading-none text-wtf-persianRed">
                <br />
                AI Nude Generator
                <br />
              </span>
            </>
          }
          subTitle={'Generate Spicy AI Images with Ease'}
          mainText={
            "Ever wondered how any fictional character would look nude? There's no need to guess anymore – see for yourself!"
          }
          imgSrc={'/sections/ai-porn-game/main.jpg'}
          imgSrcMobile={'/sections/ai-porn-game/main.jpg'}
          ctaLink={'/ai-girls'}
          ctaText={'Try Now'}
        />
        <StepsSection
          title={'How to use AI nude generator'}
          imgSrc={'/sections/ai-porn-game/wild.jpg'}
          imgAlt={'AI Girl standing in nature '}
          stepOneTitle={'Pick or Create Your AI Woman'}
          stepOneSection={
            <p className="text-wtf-white">
              Our extensive{' '}
              <Link href={'/ai-girls'} className={'!underline font-semibold'}>
                catalog
              </Link>{' '}
              is bursting with beautiful women: blonde, ginger, brunette, slim,
              or curvy. Choose any (or all!) to match your fantasies. Select the
              &apos;Photo Content&apos; tag to ensure that your character is
              ready for wild AI images. By default, every AI girl{' '}
              <Link
                href={'/create-your-ai-girlfriend'}
                className={'!underline font-semibold'}
              >
                you create
              </Link>{' '}
              is equipped for photo content. But, what exactly does &apos;photo
              content&apos; entail?
            </p>
          }
          stepTwoTitle={'Explore Our AI Nude Generator'}
          stepTwoSection={
            <p className="text-wtf-white">
              Simply click the camera icon while you&apos;re chatting with your
              seductive AI woman, and our nude AI generator will appear! This is
              where everything becomes possible: customize her poses, emotions,
              and setting to create the perfect scene. Generate those spicy
              photos you&apos;ve been dreaming of!
            </p>
          }
          stepThreeTitle={'Combine AI-Generated Nudes with a Story!'}
          stepThreeSection={
            <p className="text-wtf-white">
              Immerse yourself in an incredibly spicy narrative with your
              beloved nude AI girl. Engage in conversations that will
              undoubtedly blow your mind!
            </p>
          }
        />
        <br />
        <div className="text-center">
          <CtaBtn href={'/ai-girls'} text={'Try Now'} />
        </div>
        <FeatureRightImgSection
          title={'AI Generated Nude Women'}
          imgSrc={'/sections/ai-porn-game/cat.jpg'}
          imgAlt={'Asial ai girl with cat ears'}
          textStructure={
            <p>
              Take a glance at our SFW (Safe For Work) characters gallery
              (Blonde girl{' '}
              <Link
                href={'/gallery/alina'}
                className={'!underline font-semibold'}
              >
                Alina
              </Link>{' '}
              or ginger cutie{' '}
              <Link
                href={'/gallery/evelyn'}
                className={'!underline font-semibold'}
              >
                Evelyn
              </Link>
              ) for a glimpse into the generator&apos;s capabilities. In the
              gallery, our AI women might appear shy, but you&apos;re just a
              step away from unlocking the spicy content to generate
              AI-generated nudes on your <own className=""></own>
            </p>
          }
        />
        <FeatureLeftImgSection
          redTitle={'Story with pictures'}
          sectionTitle={'Enjoy Mind-Blowing Stories'}
          imgSrc={'/sections/ai-porn-game/club.jpg'}
          imgAlt={''}
          textStructure={
            <>
              <p className={'text-xs'}>
                Interact with each character, diving deep into their
                personalities and backstories. Some AI women may appear reserved
                but{' '}
                <Link href={'/chat/liz'} className={'!underline font-semibold'}>
                  {' '}
                  hide lewd thoughts
                </Link>{' '}
                you can discover. Others might act cool or distant initially,
                but as you get to know them, they reveal a more inviting side –
                just like real life!
              </p>
            </>
          }
        />
        <div className="text-center">
          <CtaBtn href={'/ai-girls'} text={'Try Now'} />
        </div>
        <br />
        <br />
        <br />
        <SimpleFaq
          content={faqContent}
          ctaText={'Try Now'}
          ctaLink={'/ai-girls'}
        />
      </main>
      <Footer />
    </>
  );
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['header', 'footer'])),
    },
  };
}
